/* eslint-disable camelcase */

import { ArchiveDeleteResponse } from "components/common/ArchiveDialog/ArchiveDialog";
import { SWRConfiguration } from "swr";
import { ServerResponse, ApiResponse } from "./axiosConfig";
import { useSwr, axiosInst } from "./axiosHVS";

export interface UsersApiResponse<T> {
  data: T[];
  ok: boolean;
  totalCount: number;
}

export interface UserGroupDetail {
  id: string;
  name: string;
  is_personal: string;
  type: string;
}

export interface UserPhoneAttribute {
  id: string;
  number: string;
}

export interface UserDeviceAttribute {
  id: string;
  name: string;
}

type UserAttribute = UserPhoneAttribute | UserDeviceAttribute;

export interface UsersDomain {
  email: string;
  id: string;
  name: string;
  surname: string;
  groups_details: UserGroupDetail[];
  password: string;
  password_exp_timestamp: string;
  attributes: Record<string, UserAttribute>;
  username?: string;
  is_integration?: boolean;
  enabled?: boolean;
}

export interface Device {
  device_id: string;
  device_name: string;
}

const baseKey = "/users";

const deviceBaseKey = "/me/devices";

export const useUsers = (
  config: SWRConfiguration,
  params?: {
    pageNr?: number;
    pageSize?: number;
    orderBy?: string;
    Order?: string;
    SearchKey?: string;
    viewMode?: string;
    filterByGroups?: string;
    includeGroups?: string;
    isExcludeServiceAccount?: string;
  }
): ServerResponse<UsersApiResponse<UsersDomain>> =>
  useSwr<UsersApiResponse<UsersDomain>>(
    `${baseKey}?${
      params?.includeGroups ? `includeGroups=${params?.includeGroups}` : ""
    }${
      params?.isExcludeServiceAccount
        ? `&isExcludeServiceAccount=${params?.isExcludeServiceAccount}`
        : ""
    }${
      params?.pageNr && params?.pageSize
        ? `&pageNr=${params?.pageNr}&pageSize=${params?.pageSize}`
        : ""
    }${
      params?.orderBy != null
        ? `&sortFields=${params?.orderBy}&sortOrder=${params?.Order}`
        : ""
    }${params?.SearchKey != null ? `&SearchKey=${params.SearchKey}` : ""}${
      params?.filterByGroups != null
        ? `&filterByGroups=${params.filterByGroups}`
        : ""
    }`,
    config
  );

export const useUser = (
  userId?: string,
  config?: SWRConfiguration
): ServerResponse<ApiResponse<UsersDomain>> => {
  return useSwr<ApiResponse<UsersDomain>>(`${baseKey}/${userId}`, config);
};

export const useUserTest = async (
  userId?: string
): Promise<ApiResponse<UsersDomain>> => {
  const res = await axiosInst.get(`${baseKey}/${userId}`);
  return res.data;
};

export const archiveUsers = async (
  userId: string
): Promise<ArchiveDeleteResponse<string>> => {
  const res = await axiosInst.delete(`${baseKey}/${userId}`);
  return res.data;
};

export const addUser = async (data: Partial<UsersDomain>): Promise<unknown> => {
  const res = await axiosInst.post(`${baseKey}`, data);
  return res.data;
};

export const editUser = async (
  userId: string,
  operations: unknown
): Promise<ApiResponse<UsersDomain>> => {
  const res = await axiosInst.patch(`${baseKey}/${userId}`, operations);
  return res.data;
};

export const deleteDevice = async (
  userId: string,
  data: Device
): Promise<ApiResponse<UsersDomain>> => {
  const res = await axiosInst.delete(`${deviceBaseKey}`, {
    data,
    params: {
      userId,
    },
  });

  return res.data;
};
